import { CSSProperties, MutableRefObject, ReactNode } from 'react';
import styles from './SecondaryButton.module.scss';
import { Button } from 'antd';
import { registerComponent } from '@core/Plugins/pluginManager';
import { coreUiComponentDescriptions } from '@pluginShared/core-ui-api';

export interface ISecondaryButtonProps {
    onClick?: (e: React.MouseEvent) => void;
    children: ReactNode;
    title?: string;
    style?: CSSProperties;
    disabled?: boolean;
    buttonRef?: MutableRefObject<HTMLButtonElement>;
    danger?: boolean;
}

export const SecondaryButton = registerComponent(coreUiComponentDescriptions.SecondaryButton, _SecondaryButton);

function _SecondaryButton(props: ISecondaryButtonProps) {
    return <Button
        ref={props.buttonRef}
        title={props.title}
        className={styles.host}
        style={{...props.style}}
        onClick={props.onClick}
        disabled={props.disabled}
        danger={props.danger}
    >
        {props.children}
    </Button>;
}
